import { errorsStore } from 'stores';

import { REGISTRATION_FORM } from '../../constants';

function _addErrors(errors: AnyObject) {
  errorsStore.add(REGISTRATION_FORM, errors);
}

export { _addErrors };
